import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DiagnosisConsultationModalConsultationPersonnelInfo extends Vue {
    @Prop(Number) readonly personnelId!: number
    @Prop(String) readonly personnelName!: string
}
